<template>
    <div class="col-md-12">
        <div class="panel panel-default">
            <div class="panel-heading">
                {{trans_heading}} ({{trans_total}}: {{sum}})
                <!--<select name="overTimeYear" id="overTimeYear" class="pull-right" v-model="selectedYear">-->
                    <!--<option :value="year" v-for="(year, index) in years">{{year}}</option>-->
                <!--</select>-->
            </div>
            <div class="panel-body">
                <plot :id="plotId" :ref="plotId" :options="options" :type="type"></plot>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import Plot from './Plot';

  export default {
    components: {'Plot': Plot},
    data() {
      return {
        trans_heading: Worklog.overTimeYear.trans_heading,
        trans_total  : Worklog.overTimeYear.trans_total,
        years        : Worklog.overTimeYear.years,
        selectedYear : Worklog.overTimeYear.year,
        url          : Worklog.overTimeYear.url,
        sum          : '',
        plotId       : 'overTimeYearChart',
        type         : 'bar',
        options      : {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          legend: {
            display: false
          }
        },
      }
    },
    watch     : {
      selectedYear: function (val) {
        this.fetchData();
      },
    },
    mounted() {
      this.sum = Worklog.overTimeYear.data.sum;
      this.$refs[ this.plotId ].updateChart(Worklog.overTimeYear.data.data);
    },
    methods   : {
      fetchData() {
        axios.get(this.url.replace(':year', this.selectedYear))
          .then(response => {
            response.data && response.data.data && this.$refs[ this.plotId ].updateChart(response.data.data);
            response.data && response.data.sum && (this.sum = response.data.sum);
          })
          .catch(e => {
            this.$refs[ this.plotId ].updateChart({
              dataSets: [],
              labels  : []
            });
          })
      }
    }
  }
</script>
